import React, { useContext } from "react";
import styles from "./video.module.css";
import { LanguageContext } from "../../context/LanguageContext";
function Video() {
  const { data } = useContext(LanguageContext);
  return (
    <div className={styles.showcase}>
      <video autoPlay loop muted>
        <source src={`${data.backgroundVideo.video}`} type="video/mp4" />
      </video>
      <div className={styles.overlay}></div>
      <div className={styles.text}>
        <h1>{data.backgroundVideo.text}</h1>
      </div>
    </div>
  );
}

export default Video;
